import { uniquenessCheck, API_ROOT } from '../../supplementary_components/requests';
import { possibleEquipmentYears, generateRandomString } from "../../supplementary_components/supplementaryMethods";
import { purchaseTypeAddColumn } from "../reports/purchaseTypeOptions";

export const TRAILER_ADD_CONF = {
    formAccessLevel: { key: 'TRAILERS', level: 'MANAGE' },
    formTitle: "Add Trailer",
    name: 'addTrailerForm',
    addLink: API_ROOT+'trailers/add',
    successMessage: 'Trailer was added',
    columns: [
        {
            label: "Ownership Type",
            name: "thirdPartyTrailer",
            type: "select",
            dataset: ["Company Trailer", "Third Party Trailer"],
            onChange: val => {
                function changeInputs(formTarget, fieldNames, enable){
                    for(let fieldName of fieldNames){
                        let inputField = formTarget.querySelector(`input[name="${fieldName}"]`);
                        if(!inputField){
                            inputField = formTarget.querySelector(`select[name="${fieldName}"]`);
                        }
                        inputField.disabled = !enable;
                        inputField.parentNode.style.display = enable ? "block" : "none";
                    }
                }
                
                let target = val.target;
                let thirdPartyTrailerMode = target.value === "Third Party Trailer";  
                while (target.tagName !== "FORM" ){
                    target = target.parentNode;
                }
                const tempTrailerFields = ["ownerCompanyName"];
                const companyTrailerFields = ["vin", "make", "model", "licensePlate", "year", "purchaseType"];
                
                changeInputs(target, thirdPartyTrailerMode ?  tempTrailerFields : companyTrailerFields, true);
                changeInputs(target, thirdPartyTrailerMode ? companyTrailerFields : tempTrailerFields, false);
                
            },
            processBeforeSending: val => {
                return (val !== "Company Trailer");
            },
        },
        {
            label: "Trailer Type",
            name: "trailerType",
            type: "select",
            dataset: ["DryVan", "Reefer", "Flatbed", "StepDeck", "Tanker", "SinglePop", "DoublePop"],
            // processBeforeSending: val => {
            //     return (val === "Company Trailer");
            // },
        },
        {
            label: "Trailer Owned By",
            name: "ownerCompanyName",
            autoComplete: "off",
            customDisplayMode : "none"
        },
        {
            label: "Trailer Number",
            name: "trailerNumber",
            mandatory: true,
            autoComplete: "off",
            checks: [
                async (value, column) => new Promise(resolve => {
                    if(column.defaultValue) {
                        if(column.defaultValue() === value){
                            resolve(null);
                            return;
                        }
                    }
                    resolve(uniquenessCheck(API_ROOT+"trailers/exists", "trailerNumber", value, "Trailer with this number already exists"));
                }),
            ]
        },
        {
            label: "Vin",
            name: "vin",
            mandatory: true,
            autoComplete: "off",
            
            checks: [
                (value) => {
                    return value.length !== 17 ? 'Vin number must be 17 characters' : null;
                },
                async (value, column) => new Promise(resolve => {
                    if(column.defaultValue) {
                        if(column.defaultValue() === value){
                            resolve(null);
                            return;
                        }
                    }
                    resolve(uniquenessCheck(API_ROOT+"trailers/exists", "vin", value, "Trailer with this vin number already exists"));
                }),
            ],
        },
        {
            label: "Make",
            name: "make",
            mandatory: true,
        },
        {
            label: "Model",
            autoComplete: "off",
            name: "model",
        },
        {
            label: "License Plate",
            name: "licensePlate",
            mandatory: true,
            spaceAllowed: true,
            required: true,
            value: () => { return `TEMP(${generateRandomString(3)})` },
            checks: [
                async (value, column) => new Promise(resolve => {
                    if(column.defaultValue) {
                        if(column.defaultValue() === value){
                            resolve(null);
                            return;
                        }
                    }
                    resolve(uniquenessCheck(API_ROOT+"trailers/exists", 'licensePlate', value, "Trailer with this license plate number already exists"));
                }),
            ],
        },
        {
            label: "Year",
            type: "select",
            name: "year",
            dataset: possibleEquipmentYears(),
            processBeforeSending: val => {
                return (parseInt(val));
            }
        },
        purchaseTypeAddColumn(),

    ]
}
export const TEMP_TRAILER_ADD_CONF = {
    formAccessLevel: { key: 'TRAILERS', level: 'VIEW' },
    formTitle: "Add Third Party Trailer",
    name: 'addTrailerForm',
    addLink: API_ROOT+'trailers/add-third-party',
    successMessage: 'Trailer was added',
    ignoreChangesTracker: true,
    columns: [
        {
            label: "Ownership Type",
            name: "thirdPartyTrailer",
            type: "select",
            hiddenField: true,
            defaultValue: ()=>{
                return true;
            }
            // dataset: ["Company Trailer", "Third Party Trailer"],
            // onChange: val => {
            //     function changeInputs(formTarget, fieldNames, enable){
            //         for(let fieldName of fieldNames){
            //             let inputField = formTarget.querySelector(`input[name="${fieldName}"]`);
            //             if(!inputField){
            //                 inputField = formTarget.querySelector(`select[name="${fieldName}"]`);
            //             }
            //             inputField.disabled = !enable;
            //             inputField.parentNode.style.display = enable ? "block" : "none";
            //         }
            //     }
                
            //     let target = val.target;
            //     let thirdPartyTrailerMode = target.value === "Third Party Trailer";  
            //     while (target.tagName !== "FORM" ){
            //         target = target.parentNode;
            //     }
            //     const tempTrailerFields = ["ownerCompanyName"];
            //     const companyTrailerFields = ["vin", "make", "model", "licensePlate", "year"];
                
            //     changeInputs(target, thirdPartyTrailerMode ?  tempTrailerFields : companyTrailerFields, true);
            //     changeInputs(target, thirdPartyTrailerMode ? companyTrailerFields : tempTrailerFields, false);
                
            // },
            // processBeforeSending: val => {
            //     return (val !== "Company Trailer");
            // },
        },
        {
            label: "Trailer Type",
            name: "trailerType",
            type: "select",
            dataset: ["DryVan", "Reefer", "Flatbed", "StepDeck", "Tanker", "SinglePop", "DoublePop"],
            // processBeforeSending: val => {
            //     return (val === "Company Trailer");
            // },
        },
        {
            label: "Trailer Owned By",
            name: "ownerCompanyName",
            autoComplete: "off",
        },
        {
            label: "Trailer Number",
            name: "trailerNumber",
            mandatory: true,
            autoComplete: "off",
            checks: [
                async (value, column) => new Promise(resolve => {
                    if(column.defaultValue) {
                        if(column.defaultValue() === value){
                            resolve(null);
                            return;
                        }
                    }
                    resolve(uniquenessCheck(API_ROOT+"trailers/exists", "trailerNumber", value, "Trailer with this number already exists"));
                }),
            ]
        }
    ]
}